import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-not-authenticated',
  templateUrl: './not-authorized.component.html',
  styleUrl: './not-authorized.component.scss'
})
export class NotAuthorizedComponent {
  constructor(private translateService: TranslateService, private spinner: NgxSpinnerService, private titleService: Title) { }

  ngOnInit() {
    this.spinner.hide();
    this.setTitle();
  }

  setTitle() {
    this.translateService.get('NotAuthorized').subscribe((translation: any) => {
      this.titleService.setTitle(translation + " - Polywin");
    });
  }
}
